import React from 'react'
import {
  Button,
  FormInputText,
  FormInputTextArea,
  Alert
} from 'camino-react'

import { cloudhelpPost } from 'Utilities/CloudHelp'
import Modal from 'Components/Modal'

class CopyModal extends React.Component {
  constructor (props) {
    super()

    const { show, ticket } = props

    this.state = {
      show,
      title: '',
      description: '',
      ticket: null,
      submitButtonText: 'Create'
    }
  }

  componentWillReceiveProps (newProps) {
    const { show, ticket } = newProps

    this.setState({ show, ticket })
  }

  submit = () => {
    const { title, description, ticket: { copyApiTicketPath } } = this.state

    this.setState({ submitButtonText: 'Creating...' })

    const data = { title, description }

    cloudhelpPost(copyApiTicketPath, data)
      .then(({ data }) => {
        window.location.href = data.redirectUrl
      })
  }

  removeModal = (value) => {
    this.setState({ show: value })
  }

  render () {
    const {
      removeModal,
      submit
    } = this
    const {
      show,
      title,
      description,
      ticket,
      submitButtonText
    } = this.state

    return (
      <Modal showModal={show} title={`Copy ticket ${ticket ? `#${ticket.ticketId} - ${ticket.ticketTitle}` : ''}`} removeModal={() => removeModal(false)}>
        <Alert type="info" title="Please note">
          The created ticket will have all comments, attachments and details duplicated
        </Alert>

        <div className="row row--small-gutters row--bottom-spaced">
          <div className="col">
            <label htmlFor="ticket_title">
              Title
              <FormInputText
                type="text"
                id="ticket_title"
                name="ticket[title]"
                value={title}
                onValue={text => this.setState({ title: text })}
              />
            </label>
          </div>
        </div>

        <div className="row row--small-gutters row--bottom-spaced">
          <div className="col">
            <label htmlFor="ticket_description">
              Description
              <FormInputTextArea
                rows="3"
                id="ticket_description"
                name="ticket[description]"
                value={description}
                onValue={text => this.setState({ description: text })}
              />
            </label>
          </div>
        </div>

        <div className="form-section">
          <div className="form-section__actions form-section__actions--space-between">
            <button type="button" className="button button--secondary form-section__action" onClick={() => removeModal(false)}>
              Cancel
            </button>
            <button name="commit" onClick={() => submit()} value={submitButtonText} className="button" type="submit">
              Submit
            </button>
          </div>
        </div>
      </Modal>
    )
  }
}

export default CopyModal
